







































































































































































































































import '@/polyfills';
import {Component, Mixins, Vue, Watch} from 'vue-property-decorator';
import axios from '@/plugins/axios';
import {PaymentOptions, Sex} from '@/types/CheckoutFormData';
import {ErrorCodes, Option, Product} from '@/types/CheckoutServerData';
import NiceCheckbox from '@/components/NiceCheckbox.vue';

import Section from '@/components/Section.vue'
import Address from '@/components/Address.vue'
import OptionsList from '@/components/OptionsList.vue'
import ProductList from '@/components/ProductList.vue'
import {Mixin} from "@/mixins";
import store from '@/store';
import {SectionType} from '@/types/enums';
import AdditionalOptions from '@/components/AdditionalOptions.vue';
import {captureException} from "@sentry/browser";
import * as Sentry from "@sentry/vue";

@Component({
        components: {
            Section,
            Address,
            OptionsList,
            ProductList,
            NiceCheckbox,
            AdditionalOptions,
        },
        mixins: [
            Mixin
        ],
        name: "Checkout",
    })
    export default class Checkout extends Mixins(Mixin) {
        @Watch('store.serverData.payment')
        onPaymentMethodChange() {
            this.boniversumCheckFailed = false;
        }

        @Watch('store.hasErrorOnBuy')
        onHasErrorOnBuyChange(val: boolean) {
            if (val) {
                this.scrollToError();
            }
        }

        // because vue
        SectionType = SectionType;
        isProduction = isProduction;
        store = store();

        nextSection: SectionType | null = null;

        openAllSections = false;

        firstAjax = true;

        checkingBoniversum: boolean = false;
        boniversumCheckFailed: boolean = false;

        get selectedPayment(): Option|undefined {
          if (typeof this.store.serverPaymentOptions === 'undefined') {
            return undefined;
          }

          return Object.values(this.store.serverPaymentOptions).find((payment) => {
            return payment.id === this.store.serverData.payment;
          });
        }

        get productsHasDifferentDeliveryTimes(): boolean {
            if (this.store.flatProducts.length <= 1) {
                return false;
            }

            const product = this.store.flatProducts.find(product => !!product.delivery);

            if (!product) {
                return false;
            }

            return this.store.flatProducts
                    .filter(product => !!product.delivery)
                    .some(({delivery}) => {
                        return delivery!.from !== product.delivery!.from || delivery!.to !== product.delivery!.to;
                    });
        }

        get maxDeliveryFrom(): number {
            return Math.max(...this.store.flatProducts.map(cur => cur.delivery ? cur.delivery.from : 0));
        }

        get maxDeliveryTo(): number {
            return Math.max(...this.store.flatProducts.map(cur => cur.delivery ? cur.delivery.to : 0));
        }

        get selectPaymentMethodButtonLabel(): string {
            return this.checkingBoniversum
                ? this.T('ch2-checking-boniversum')
                : this.T('ch2-next');
        }

        private get deliveryAddressReadonlyInputs(): string[] {
            return this.store.serverData.hasDifferentBillingAddress
                && this.store.serverData.personalizedCart
                && this.store.serverData.personalizedCart.mandatoryAssembly
                ? ['country'] : [];
        }

        private get billingAddressReadonlyInputs(): string[] {
            return !this.store.serverData.hasDifferentBillingAddress
                && this.store.serverData.personalizedCart
                && this.store.serverData.personalizedCart.mandatoryAssembly
                ? ['country'] : [];
        }

        get sortedPaymentOptions(): { [key: string]: Option } {
            let paymentOptions: { [key: string]: Option } = {}
            if (typeof this.store.serverPaymentOptions !== 'undefined') {
              for (const paymentOption of Object.values(this.store.serverPaymentOptions).sort((a, b) => (a.sort_index! - b.sort_index!))) {
                paymentOptions[paymentOption.sort_index!.toString()] = paymentOption;
              }
            }
            return paymentOptions;
        }

        async selectedPaymentMethod(next: () => void): Promise<void> {
            if (!this.selectedPayment!.creditCheck) {
                next();
                return;
            }

            this.checkingBoniversum = true;

            const data = {
                price: this.store.serverData.totalPriceNumber / 100.0,
                customer: {
                    billingAddress: this.store.serverData.billingAddress,
                    deliveryAddress: this.store.serverData.deliveryAddress,
                    birthDate: this.store.serverData.invoice.birthDate,
                },
                _token: this.store.serverData.token,
            };

            let invoiceAvailable = false;

            try {
                const result = await axios.post('/api/cart/credit-check', data);
                invoiceAvailable = result.data.invoiceAvailable;
            } catch (e) {
                console.error(e);
            }

            if (invoiceAvailable) {
                next();
            } else {
                if (this.store.serverData.payment > -1) {
                    this.store.removePaymentOptionByIndex(this.store.serverData.payment)
                }

                const fallbackPaymentId = Object.keys(this.store.serverPaymentOptions)[0];
                this.store.serverData.payment = this.store.serverPaymentOptions[parseInt(fallbackPaymentId)].id!;
                await this.$nextTick();
                this.boniversumCheckFailed = true;
            }

            this.checkingBoniversum = false;
        }

        async buy() {
            await this.store.buy();
            this.scrollToError();
        }

        async sendAjax() {
            await this.store.syncServer();
        }

        async countryChanged() {
            await this.store.syncServer();
        }

        resetForm(reload = false) {
            window.sessionStorage.removeItem('ch2-formData');
            if (reload) {
                window.location = location;
            }
        }

        async mounted() {
            if (typeof this.store.serverData.errors.payment !== 'undefined'
                && this.store.serverData.errors.payment.code === ErrorCodes.REDIRECT) {
                this.store.showErrorsInSection(SectionType.Address);
                this.store.showErrorsInSection(SectionType.Shipping);
                this.store.showErrorsInSection(SectionType.Payment);
                this.store.currentSection = SectionType.Payment;
                this.scrollToError();
            }

            document.querySelectorAll('.header-inside > .show-in-checkout').forEach((el) => {
                (el as HTMLElement).style.removeProperty('display');
            });

            document.querySelectorAll('.header-inside > *:not(.show-in-checkout)').forEach((el) => {
                (el as HTMLElement).style.setProperty('display', 'none', 'important');
            });

            if (Object.keys(this.store.availableCountries!).length === 0) {
                await this.store.loadCountries();
            }

            if (Object.keys(this.store.serverPaymentOptions!).length === 0) {
                await this.store.loadPaymentOptions();
            }
        }

        async openSection(section: SectionType, sendAjax = true) {
            this.nextSection = section;
            if (sendAjax) {
                try {
                    await this.sendAjax();
                } catch (e) {
                    // do nothing
                }
            }

            if (
                section === SectionType.Address
                && Object.keys(this.store.availableCountries!).length === 0
            ) {
                await this.store.loadCountries();
            } else if (section === SectionType.Shipping) {
                this.store.showErrorsInSection(SectionType.Address);
                if (this.store.serverData.errors.internationalDelivery) {
                    this.scrollToError();
                    return false;
                }
                // if we have billingAddress or deliveryAddress errors (the latter only when isDeliveryAddressDifferent is checked)
                if ((typeof this.store.serverData.errors.billingAddress !== 'undefined'
                    && Object.keys(this.store.serverData.errors.billingAddress).length != 0)
                    || (this.store.serverData.hasDifferentBillingAddress
                        && (typeof this.store.serverData.errors.deliveryAddress !== 'undefined'
                            && Object.keys(this.store.serverData.errors.deliveryAddress).length != 0))) {
                    this.scrollToError();
                    return false;
                }
                if (this.store.serverData.shipping === null || typeof this.store.availableShippingOptions[this.store.serverData.shipping] === 'undefined') {
                    const carrierId = Object.keys(this.store.availableShippingOptions).find((key) => {
                        return this.store.availableShippingOptions[parseInt(key)]!.default;
                    })!;
                    this.store.serverData.shipping = parseInt(carrierId);

                    if (sendAjax) {
                        try {
                            await this.sendAjax();
                        } catch (e) {
                            // do nothing
                        }
                    }
                }

                try {
                    this.showLoader();
                    await this.store.loadPaymentOptions();
                } catch (e) {
                    Sentry.captureException(e);
                    this.store.showErrorsInSection(SectionType.Shipping);
                } finally {
                    this.hideLoader();
                }
            }
            if (section === SectionType.Payment) {
                this.store.showErrorsInSection(SectionType.Shipping);
                if (typeof this.store.serverData.errors.shipping !== 'undefined') {
                    this.scrollToError();
                    return false
                }
                if (this.store.serverData.totalPriceNumber <= 0 && this.store.serverData.payment !== 0) {
                    await this.openSection(SectionType.Options);
                    return;
                }

                if (this.store.serverData.payment === 0 || typeof this.selectedPayment === 'undefined') {
                    let defaultPayments = Object.values(this.store.serverPaymentOptions).filter(payment => payment.default);

                    this.store.serverData.payment = defaultPayments.length > 0
                        ? defaultPayments[0].id!
                        : Object.values(this.store.serverPaymentOptions)[0].id!;

                    if (this.store.serverData.totalPriceNumber <= 0) {
                        await this.openSection(SectionType.Options);
                        return;
                    }

                    if (sendAjax) {
                        try {
                            await this.sendAjax();
                        } catch (e) {
                            captureException(e);
                            // do nothing
                        }
                    }
                }
            }
            if (section === SectionType.Options) {
                this.store.showErrorsInSection(SectionType.Payment);

                if (
                    typeof this.selectedPayment !== 'undefined'
                    && this.selectedPayment.module === PaymentOptions.CreditCard
                ) {
                    this.store.validateCreditCard();
                }
                if (typeof this.store.serverData.errors.payment !== 'undefined'
                    || (typeof this.store.serverData.errors.creditCard !== 'undefined'
                        && Object.keys(this.store.serverData.errors.creditCard).length > 0)) {
                    this.scrollToError();
                    return false
                }
                if (typeof this.store.serverData.errors.payment !== 'undefined'
                    || (typeof this.store.serverData.errors.invoice !== 'undefined'
                        && Object.keys(this.store.serverData.errors.invoice).length > 0)) {
                    this.scrollToError();
                    return false
                }
            }

            // turn off assembly if not available
            if (!this.store.serverData.additionalOptions.assembly || !this.store.serverData.additionalOptions.assemblyData.canOrder) {
                this.store.serverData.additionalOptions.assembly = false;
            }

            this.store.currentSection = section;
            this.nextSection = null;

            await this.$nextTick();
            setTimeout(() => {
                const sectionVue = (<Vue>this.$refs['section' + this.store.currentSection]);
                if (sectionVue) {
                    let top = sectionVue.$el.getBoundingClientRect().top
                        + window.scrollY
                        -((<HTMLDivElement>document.getElementById('header')).clientHeight)
                        - 5;

                    window.scroll({
                        top,
                        behavior: 'smooth',
                    });
                }
            }, 200);
        }

        showLoader() {
            this.store.loading = true;
        }

        hideLoader() {
            this.store.loading = false;
        }

        scrollToError() {
            setTimeout(() => {
                let sectionVue = (<Vue>this.$refs['section' + this.store.currentSection]);
                if (sectionVue) {
                    let elements = [
                        ...sectionVue.$el.getElementsByClassName('ch2-buy-error'),
                        ...sectionVue.$el.getElementsByClassName('error'),
                        ...sectionVue.$el.getElementsByClassName('alert-danger')
                    ];
                    let element;
                    if (elements.length === 0) {
                        element = sectionVue.$el;
                    } else {
                        element = elements[0];
                    }

                    let top = element.getBoundingClientRect().top
                        + window.scrollY
                        -((<HTMLDivElement>document.getElementById('header')).clientHeight)
                        - 5;

                    window.scroll({
                        top,
                        behavior: 'smooth',
                    });
                }
            }, 200);
        }

        private changeIsDeliveryAddressDifferent(isDifferent: boolean): void {
            this.store.serverData.hasDifferentBillingAddress = isDifferent;

            if (isDifferent) {
                if (this.store.serverData.deliveryAddress === null) {
                    this.store.serverData.deliveryAddress = {
                      sex: Sex.Female,
                      name: '',
                      surname: '',
                      addition: '',
                      hasCompany: false,
                      company: '',
                      vatNumber: '',
                      street: '',
                      zipcode: '',
                      city: '',
                      country: 1,
                      phone: '',
                      email: '',
                    };
                }
                this.store.serverData.deliveryAddress.country = this.store.serverData.billingAddress.country;
                this.store.serverData.deliveryAddress.zipcode = this.store.serverData.billingAddress.zipcode;
            } else {
                this.store.serverData.billingAddress.country = this.store.serverData.deliveryAddress.country;
                this.store.serverData.billingAddress.zipcode = this.store.serverData.deliveryAddress.zipcode;
            }
        }

        get isOnlyWoodSamples() {
            return this.store.flatProducts.filter((product: Product) => product.id === 'w').length === this.store.flatProducts.length;
        }

        @Watch('this.store.availableCountries')
        onCountriesChanges() {
            if (typeof this.store.availableCountries![this.store.serverData.billingAddress.country] === 'undefined') {
                this.store.serverData.billingAddress.country = 1; //Country.Germany;
            }
            if (typeof this.store.availableCountries![this.store.serverData.deliveryAddress.country] === 'undefined') {
                this.store.serverData.deliveryAddress.country = 1; //Country.Germany;
            }
        }

        @Watch('store.serverData.newsletter')
        onNewsletterChange() {
            delete this.store.serverData.errors.newsletter;
        }

        @Watch('store.serverData.additionalOptions.assembly')
        onAssemblyChange() {
            this.sendAjax();
        }

        @Watch('store.serverData.agb')
        async onAgbChange(newVal: any, oldVal: any) {
          if (typeof newVal !== 'undefined') {
            await this.store.syncServer();
            if (this.store.serverData.agb && window.innerWidth >= 1024) {
              let top = (<HTMLElement>document.getElementById('checkout')).getBoundingClientRect().top
                  + window.scrollY
                  -((<HTMLDivElement>document.getElementById('header')).clientHeight);

              window.scroll({
                top,
                behavior: 'smooth',
              });
            }
          }
        }
    }
